import React from "react";
import { LegalHero, LegalBody } from "./legalHelpers";
import FAQAccordion from "../components/HomepageFAQ";
import { usePageMeta } from "../components/Layout";
import { ALL_FAQS } from "../lib/faqData";


export default function FAQsPage() {
    usePageMeta({
        title: "FAQs | London Renovation Specialists",
        description: "Answers to common questions about our free home renovation design service in London.",
    });
    return (
        <div data-testid="faqs-page">
            <LegalHero
                eyebrow="Answers"
                title="Frequently asked questions"
                intro="Answers to the questions we're asked most often about our free design service, our process, and what happens if you decide to use another designer or builder."
            />
            <LegalBody>
                <FAQAccordion items={ALL_FAQS} testIdPrefix="page-faq" />
            </LegalBody>
        </div>
    );
}
